export const buildCalledFinishFormData = ({
  calledGridData,
  calledId,
  targetStatusId,
  userId,
  description,
  privacy = false,
  files = [],
  closingFormData = null,
  closingFormData2 = null,
}) => {
  const newData = new FormData();

  newData.append('Id', calledGridData.id);
  newData.append('Title', calledGridData.title ?? '');
  newData.append('Description', calledGridData.description ?? ' ');
  newData.append('Status', targetStatusId);
  newData.append('Type', calledGridData.typeid ?? 0);
  newData.append('Organization', calledGridData.organizationid ?? 0);
  newData.append('OrganizationCategory', calledGridData.organizationcategoryid ?? 0);
  newData.append('RequestingUser', calledGridData.requestinguserid ?? 0);
  newData.append('OriginRequest', calledGridData.originrequestid ?? 0);
  newData.append('AddressId', calledGridData.addressid ?? 0);
  newData.append('AssignedUser', calledGridData.assigneduserid ?? 0);
  newData.append('TechinicalTeamId', calledGridData.techinicalteamid ?? 0);
  newData.append('ObservantUser', calledGridData.observantuserid ?? 0);
  newData.append('UpdatedUser', userId ?? 0);

  newData.append('Accompaniment.called', calledId ?? calledGridData.id);
  newData.append('Accompaniment.finish', true);
  newData.append('Accompaniment.CalledStatus', targetStatusId);
  newData.append('Accompaniment.userAction', userId ?? 0);
  newData.append('Accompaniment.calledTitle', calledGridData.title ?? '');
  newData.append('Accompaniment.privacy', privacy ? 'true' : 'false');
  newData.append('Accompaniment.description', description ?? '');
  newData.append('Accompaniment.originid', 2);
  newData.append('Accompaniment.CalledOrganizationCategory', calledGridData.organizationcategoryid ?? 0);
  newData.append('Accompaniment.CalledType', calledGridData.typeid ?? 0);
  newData.append('Accompaniment.CalledDescription', calledGridData.description ?? ' ');
  newData.append('Accompaniment.CalledAddressId', calledGridData.addressid ?? 0);
  newData.append('Accompaniment.CalledAssignedUser', calledGridData.assigneduserid ?? 0);
  newData.append('Accompaniment.CalledObservantUser', calledGridData.observantuserid ?? 0);
  newData.append('Accompaniment.RequestingUser', calledGridData.requestinguserid ?? 0);

  files.forEach((file) => {
    if (file instanceof File) {
      newData.append('Accompaniment.filesUpload', file);
    }
  });

  if (closingFormData && typeof closingFormData.entries === 'function') {
    for (const [key, value] of closingFormData.entries()) {
      newData.append(`CalledTipping.${key}`, value);
    }
  }

  if (closingFormData2 && typeof closingFormData2.entries === 'function') {
    for (const [key, value] of closingFormData2.entries()) {
      newData.append(`CalledClosing.${key}`, value);
    }
  }

  return newData;
};
